import { CardRouterOrigin } from './card-selected.types';

export const isCardFromExternalLink = (
    originRoute: CardRouterOrigin,
): boolean => originRoute === CardRouterOrigin.EXTERNAL_LINK;
